var map = {
	"./access-from-anywhere.svg": "E+qO",
	"./easily-access-credit-cards.svg": "SFnC",
	"./faster-login.svg": "rqTX",
	"./friendly-design.svg": "qgjm",
	"./independently-audited@2x.png": "o34E",
	"./never-forget-password.svg": "3+Gb",
	"./save-time.svg": "57Hz",
	"./secure-notes.svg": "se6s",
	"./secured-end-to-end.svg": "Rqlq",
	"./serious-security.svg": "JQLz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sRL0";


//////////////////
// WEBPACK FOOTER
// ./src/components/img-text/images ^\.\/.*$
// module id = sRL0
// module chunks = 26